// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"12":"profiler","777":"recorder"}[chunkId] + "." + {"12":"95c9739d02eaa2d9","777":"2b5ae8b40b8e70f8"}[chunkId] + ".js";
};